export enum SimulationTableRowKey {
  DATE = 'date',
  STATUS = 'status',
  QUOTE_CONTRACT = 'quoteContract',
  FOLDER_IDENTIFIER = 'folderIdentifier',
  SOURCE = 'source',
  INSUREDS = 'insureds',
  BRANCH = 'branch',
  PRODUCTS = 'products',
  UNREAD_NOTIFICATION_COUNT = 'unreadNotificationCount',
}
